const Colors = {
  // primary: "#34f2c6", //wupo's color
  // primary: "#0F3876", //Dark blue 0F3876
  primary: "#1c2444",    // Navy blue, #1c2444
  secondary: "#1c2444",  // Navy blue, #1c2444  
  third: "#E2062C",      // Bright red, #E2062C
  hover: "#021B79",      // Dark blue, #021B79

  fourth: "#C28100",     // Golden brown, #C28100
  fifth: "#C7C4C4",      // Light gray, #C7C4C4
  credit: "#6DD47E",     // Mint green, #6DD47E
  debit: "#ff003f",      // Bright red, #ff003f
  labelColor: "#333",    // Dark gray, #333
  button1: "#c7357c",    // Deep pink, #c7357c
  button2: "#6DD47E",    // Mint green, #6DD47E
  button3: "#FFD55A"     // Golden yellow, #FFD55A
}

export default Colors